import * as types from './LiveAvailableShiftsActionType';


export const fetchLiveAvailableShiftsRequest = (payload) => ({
    type: types.FETCH_LIVE_AVAILABLE_SHIFTS_REQUEST,
    payload,
});
export const fetchLiveAvailableShiftsSuccess = (payload) => ({
    type: types.FETCH_LIVE_AVAILABLE_SHIFTS_SUCCESS,
    payload,
});
export const fetchLiveAvailableShiftsFailure = (error) => ({
    type: types.FETCH_LIVE_AVAILABLE_SHIFTS_FAILURE,
    error,
});

export const fetchLegendTableDataRequest = (payload) => ({
    type: types.FETCH_LEGEND_TABLE_DATA_REQUEST,
    payload,
});
export const fetchLegendTableDataSuccess = (payload) => ({
    type: types.FETCH_LEGEND_TABLE_DATA_SUCCESS,
    payload,
});
export const fetchLegendTableDataFailure = (error) => ({
    type: types.FETCH_LEGEND_TABLE_DATA_FAILURE,
    error,
});